import styled from "styled-components";
import { useMemo, type ReactNode, } from "react";
import { Slate, } from "@bracket/ui/nodes";
import type { CssSpaceValue, } from "@bracket/ui/types";
import type { PrefixKeys, } from "@bracket/sharedTypes";


export declare type BraceProps = {
	children?: ReactNode;
	height?: CssSpaceValue;
	width?: CssSpaceValue;
	padding?: CssSpaceValue;
	margin?: CssSpaceValue;
	highest?: boolean;
	higher?: boolean;
	high?: boolean;
	low?: boolean;
	lower?: boolean;
	lowest?: boolean;
	flexible?: boolean;
	fill?: boolean;
	gap?: CssSpaceValue;
	$debug?: boolean;
}

export const Brace = ( props: BraceProps ) => {
	const { children, ...rest } = props;
	return <BraceNode {...rest}>{children}</BraceNode>;
} 

const BraceNode = styled(Slate).attrs<BraceProps>(props => {
	const $props = useMemo(() => Object.entries(props).reduce((acc, [k, v])=> Object.assign(acc, { [`$${k}`]: v }), {} as PrefixKeys<"$", BraceProps>), [props]);
	return {
		$strata: $props.$highest ? "highest" : $props.$higher ? "high" : $props.$high ? "default" : $props.$low ? "low" : $props.$lowest ? "lowest" : "default",
		...$props,
	}
})``;
